import DashboardLayout from '../components/DashboardLayout';
import QueueList from '../components/QueueList';

export default function QueueListPage(){
  return (
    <DashboardLayout>
      <QueueList></QueueList>
    </DashboardLayout>
  )
}